var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8103_3215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 6L11.6875 4.34375L14.8125 4.8125C15.5 6 15.9062 7.3125 15.9688 8.65625L13.7188 10.625L11.8125 9.84375L10.5625 6ZM8.34375 12.8438L11.5938 10.5L13.4375 11.2812L13.7188 14.5938C12.9688 15.3438 12.1562 15.9375 11.2188 16.3438L8.34375 14.9375V12.8438ZM4.84375 3.9375L6.3125 1.1875C7.40625 0.96875 8.5625 0.96875 9.65625 1.1875L11.125 3.9375L9.96875 5.59375H6L4.84375 3.9375ZM14.125 11.1875L15.9688 9.59375C15.8438 11.1562 15.3125 12.625 14.3438 13.8438L14.125 11.1875ZM1.71875 4.03125C2.6875 2.84375 3.9375 1.9375 5.375 1.4375L4.21875 3.65625L1.71875 4.03125ZM0 8.65625C0.0625 7.3125 0.46875 5.96875 1.15625 4.8125L4.28125 4.34375L5.40625 6L4.15625 9.8125L2.25 10.625L0 8.65625ZM2.25 14.5938L2.53125 11.2812L4.375 10.5L7.625 12.8438V14.9375L4.75 16.3438C3.8125 15.9062 2.96875 15.3438 2.25 14.5938ZM0 9.59375L1.84375 11.1875L1.625 13.8438C0.6875 12.625 0.125 11.1562 0 9.59375ZM5.65625 16.6562L7.96875 15.5312V15.5625L8 15.5312L10.3125 16.6562C9.5625 16.9062 8.78125 17 8 17C7.1875 17 6.40625 16.9062 5.65625 16.6562ZM4.84375 9.96875L6.0625 6.28125H9.90625L11.125 9.96875L8 12.25L4.84375 9.96875ZM14.25 4.03125C13.2812 2.84375 12.0312 1.9375 10.5938 1.4375L11.75 3.65625L14.25 4.03125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8103_3215",
    x: 0,
    y: 0.96875,
    width: 15.9688,
    height: 17.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8103_3215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8103_3215",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default ForwardRef;